/**
 * Created by Andromeda on 12/3/16.
 */
'use strict';

angular.module('mean.admin').controller('ProfileController', ['$scope', 'Global', 'Menus', 'MeanUser', 'Users', 'toaster', function($scope, Global, Menus, MeanUser, Users, toaster) {
  $scope.global = Global;
  $scope.package = {
    name: 'admin'
  };
  $scope.profile = {};
  var userName = MeanUser.user.username;
  $scope.isACPermission = userName.slice(userName.length - 4) === '0000' ? true : false;

  Users.query({'_id': MeanUser.user._id}, function(user) {
    $scope.profile_user = user[0];
  });

  $scope.updateProfile = function() {
    console.log('in updateProfile');
    $scope.profile_user.$update().then(function(result) {
      toaster.pop('success', 'Profile', 'Saved');
    }, function(reason) {
      toaster.pop('error', 'Profile', reason);
    });
  };
}]);



// WEBPACK FOOTER //
// ./packages/custom/admin/public/controllers/profile.js